import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './modules/login/services/auth/auth.service';
import { User } from 'src/app/models/user';
import { UserIdleService } from 'angular-user-idle';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  dialogConfig:any;
  _user: any;
  loading:boolean = false;
  once:boolean = true;

  title = 'Cash Advance Portal';

  constructor(
    public auth: AuthService,
    private userIdle: UserIdleService,
    private _router: Router,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    const eachSecond$ = Observable.timer(0, 5000); // starts at 0 and gives 1,2,3 as values each 1000 milliseconds.
    const mouseMove$ = Observable.fromEvent<MouseEvent>(document, 'mousemove');
    
    const mouseMoveEachSecond$ = mouseMove$.sample(eachSecond$);
    
    mouseMoveEachSecond$.subscribe( x => {
      this.userIdle.resetTimer();

      if (this.auth.isAuthenticated()) {
        this._user = new User(this.auth.getAuthUser());

        //Start watching for user inactivity.
        this.userIdle.startWatching();
        
        // Start watching when user idle is starting.
        this.userIdle.onTimerStart().subscribe();
        
        // Start watch when time is up.
        this.userIdle.onTimeout().subscribe(() => {
          this.userIdle.stopWatching();

          if (this.once) {
            this.dialog.open(NotifyboxComponent, {
              disableClose:true,
              data: {
                label:'Ok',
                reload: false,
                message: 'You have been logout due to inactivity.'
              }
            }).afterClosed().subscribe(result => {
            });

            this.once = false;
          }

          let data = {
            token: this._user.token
          }

          this.auth.logout(data).subscribe(res =>{
            this.userIdle.stopWatching();
            localStorage.removeItem('cashUser');
            localStorage.removeItem('isAdmin');
            localStorage.removeItem('token');
            this._router.navigate(["/login"]);
          },(err => {
            if (err.status == 401) {
              window.location.reload();
            }
          }));
        });
      }
    });
  }
}
